"use strict";

exports.__esModule = true;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.isChunkExpired = isChunkExpired;
exports.getChunks = getChunks;
exports.filterParams = filterParams;
exports.sum = sum;
exports.setLocalFileInfo = setLocalFileInfo;
exports.removeLocalFileInfo = removeLocalFileInfo;
exports.getLocalFileInfo = getLocalFileInfo;
exports.getResumeUploadedSize = getResumeUploadedSize;
exports.createMkFileUrl = createMkFileUrl;
exports.getHeadersForChunkUpload = getHeadersForChunkUpload;
exports.getHeadersForMkFile = getHeadersForMkFile;
exports.createXHR = createXHR;
exports.computeMd5 = computeMd5;
exports.readAsArrayBuffer = readAsArrayBuffer;
exports.request = request;
exports.getPortFromUrl = getPortFromUrl;
exports.getDomainFromUrl = getDomainFromUrl;
exports.getUploadUrl = getUploadUrl;
exports.isContainFileMimeType = isContainFileMimeType;
exports.createObjectURL = createObjectURL;
exports.getTransform = getTransform;

var _base = require("./base64");

var _config = require("./config");

var _sparkMd = require("spark-md5");

var _sparkMd2 = _interopRequireDefault(_sparkMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// 对上传块本地存储时间检验是否过期
// TODO: 最好用服务器时间来做判断
function isChunkExpired(time) {
  var expireAt = time + 3600 * 24 * 1000;
  return new Date().getTime() > expireAt;
}

// 文件分块
function getChunks(file, blockSize) {
  var chunks = [];
  var count = Math.ceil(file.size / blockSize);
  for (var i = 0; i < count; i++) {
    var chunk = file.slice(blockSize * i, i === count - 1 ? file.size : blockSize * (i + 1));
    chunks.push(chunk);
  }
  return chunks;
}

function filterParams(params) {
  return (0, _keys2["default"])(params).filter(function (value) {
    return value.startsWith("x:");
  }).map(function (k) {
    return [k, params[k].toString()];
  });
}

function sum(list) {
  return list.reduce(function (sum, loaded) {
    return sum + loaded;
  }, 0);
}

function setLocalFileInfo(file, info) {
  try {
    localStorage.setItem(createLocalKey(file), (0, _stringify2["default"])(info));
  } catch (err) {
    if (window.console && window.console.warn) {
      console.warn("setLocalFileInfo failed");
    }
  }
}

function createLocalKey(file) {
  return "qiniu_js_sdk_upload_file_" + file.name + "_size_" + file.size;
}

function removeLocalFileInfo(file) {
  try {
    localStorage.removeItem(createLocalKey(file));
  } catch (err) {
    if (window.console && window.console.warn) {
      console.warn("removeLocalFileInfo failed");
    }
  }
}

function getLocalFileInfo(file) {
  try {
    return JSON.parse(localStorage.getItem(createLocalKey(file))) || [];
  } catch (err) {
    if (window.console && window.console.warn) {
      console.warn("getLocalFileInfo failed");
    }
    return [];
  }
}

function getResumeUploadedSize(file) {
  return getLocalFileInfo(file).filter(function (value) {
    return value && !isChunkExpired(value.time);
  }).reduce(function (result, value) {
    return result + value.size;
  }, 0);
}

// 构造file上传url
function createMkFileUrl(url, file, key, putExtra) {
  var requestUrl = url + "/mkfile/" + file.size;
  if (key != null) {
    requestUrl += "/key/" + (0, _base.urlSafeBase64Encode)(key);
  }
  if (putExtra.mimeType) {
    requestUrl += "/mimeType/" + (0, _base.urlSafeBase64Encode)(file.type);
  }
  var fname = putExtra.fname;
  if (fname) {
    requestUrl += "/fname/" + (0, _base.urlSafeBase64Encode)(fname);
  }
  if (putExtra.params) {
    filterParams(putExtra.params).forEach(function (item) {
      return requestUrl += "/" + encodeURIComponent(item[0]) + "/" + (0, _base.urlSafeBase64Encode)(item[1]);
    });
  }
  return requestUrl;
}

function getAuthHeaders(token) {
  var auth = "UpToken " + token;
  return { Authorization: auth };
}

function getHeadersForChunkUpload(token) {
  var header = getAuthHeaders(token);
  return (0, _assign2["default"])({ "content-type": "application/octet-stream" }, header);
}

function getHeadersForMkFile(token) {
  var header = getAuthHeaders(token);
  return (0, _assign2["default"])({ "content-type": "text/plain" }, header);
}

function createXHR() {
  if (window.XMLHttpRequest) {
    return new XMLHttpRequest();
  }
  return new window.ActiveXObject("Microsoft.XMLHTTP");
}

function computeMd5(data) {
  return readAsArrayBuffer(data).then(function (buffer) {
    var spark = new _sparkMd2["default"].ArrayBuffer();
    spark.append(buffer);
    return spark.end();
  });
}

function readAsArrayBuffer(data) {
  return new _promise2["default"](function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(data);
    reader.onload = function (evt) {
      var body = evt.target.result;
      resolve(body);
    };
    reader.onerror = function () {
      reject(new Error("fileReader 读取错误"));
    };
  });
}

function request(url, options) {
  return new _promise2["default"](function (resolve, reject) {
    var xhr = createXHR();
    xhr.open(options.method, url);

    if (options.onCreate) {
      options.onCreate(xhr);
    }
    if (options.headers) {
      (0, _keys2["default"])(options.headers).forEach(function (k) {
        return xhr.setRequestHeader(k, options.headers[k]);
      });
    }

    xhr.upload.addEventListener("progress", function (evt) {
      if (evt.lengthComputable && options.onProgress) {
        options.onProgress({ loaded: evt.loaded, total: evt.total });
      }
    });

    xhr.onreadystatechange = function () {
      var responseText = xhr.responseText;
      if (xhr.readyState !== 4) {
        return;
      }
      var reqId = xhr.getResponseHeader("x-reqId") || "";
      if (xhr.status !== 200) {
        var message = "xhr request failed, code: " + xhr.status + ";";
        if (responseText) {
          message = message + (" response: " + responseText);
        }
        reject({ code: xhr.status, message: message, reqId: reqId, isRequestError: true });
        return;
      }
      try {
        resolve({ data: JSON.parse(responseText), reqId: reqId });
      } catch (err) {
        reject(err);
      }
    };

    xhr.send(options.body);
  });
}

function getPortFromUrl(url) {
  if (url && url.match) {
    var groups = url.match(/(^https?)/);
    if (!groups) {
      return "";
    }
    var type = groups[1];
    groups = url.match(/^https?:\/\/([^:^/]*):(\d*)/);
    if (groups) {
      return groups[2];
    }
    if (type === "http") {
      return "80";
    }
    return "443";
  }
  return "";
}

function getDomainFromUrl(url) {
  if (url && url.match) {
    var groups = url.match(/^https?:\/\/([^:^/]*)/);
    return groups ? groups[1] : "";
  }
  return "";
}

// 构造区域上传url
function getUploadUrl(config, token) {
  var protocol = getAPIProtocol();

  if (config.uphost != null) {
    return _promise2["default"].resolve(protocol + "//" + config.uphost);
  }

  if (config.region != null) {
    var upHosts = _config.regionUphostMap[config.region];
    var host = config.useCdnDomain ? upHosts.cdnUphost : upHosts.srcUphost;
    return _promise2["default"].resolve(protocol + "//" + host);
  }

  return getUpHosts(token).then(function (res) {
    var hosts = res.data.up.acc.main;
    return protocol + "//" + hosts[0];
  });
}

function getAPIProtocol() {
  if (window.location.protocol === "http:") {
    return "http:";
  }
  return "https:";
}

function getPutPolicy(token) {
  var segments = token.split(":");
  var ak = segments[0];
  var putPolicy = JSON.parse((0, _base.urlSafeBase64Decode)(segments[2]));
  putPolicy.ak = ak;
  putPolicy.bucket = putPolicy.scope.split(":")[0];
  return putPolicy;
}

function getUpHosts(token) {
  try {
    var putPolicy = getPutPolicy(token);
    var url = getAPIProtocol() + "//api.qiniu.com/v2/query?ak=" + putPolicy.ak + "&bucket=" + putPolicy.bucket;
    return request(url, { method: "GET" });
  } catch (e) {
    return _promise2["default"].reject(e);
  }
}

function isContainFileMimeType(fileType, mimeType) {
  return mimeType.indexOf(fileType) > -1;
}

function createObjectURL(file) {
  var URL = window.URL || window.webkitURL || window.mozURL;
  return URL.createObjectURL(file);
}

function getTransform(image, orientation) {
  var width = image.width,
      height = image.height;


  switch (orientation) {
    case 1:
      // default
      return {
        width: width, height: height,
        matrix: [1, 0, 0, 1, 0, 0]
      };
    case 2:
      // horizontal flip
      return {
        width: width, height: height,
        matrix: [-1, 0, 0, 1, width, 0]
      };
    case 3:
      // 180° rotated
      return {
        width: width, height: height,
        matrix: [-1, 0, 0, -1, width, height]
      };
    case 4:
      // vertical flip
      return {
        width: width, height: height,
        matrix: [1, 0, 0, -1, 0, height]
      };
    case 5:
      // vertical flip + -90° rotated
      return {
        width: height,
        height: width,
        matrix: [0, 1, 1, 0, 0, 0]
      };
    case 6:
      // -90° rotated
      return {
        width: height,
        height: width,
        matrix: [0, 1, -1, 0, height, 0]
      };
    case 7:
      // horizontal flip + -90° rotate
      return {
        width: height,
        height: width,
        matrix: [0, -1, -1, 0, height, width]
      };
    case 8:
      // 90° rotated
      return {
        width: height,
        height: width,
        matrix: [0, -1, 1, 0, 0, width]
      };
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = 12
// module chunks = 0